<template>
<div>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">  
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    
  <div class=" col-md-6 col-12 p-0">

    <div class="col-12 row mx-0 px-3 py-2" style="background-image: linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123));color:#ffffff;">
      <h3><strong>{{msglist[$route.params.language][0]}}</strong></h3><!--鈣反控制器 設定 -->
      <div class="ml-auto"><router-link :to="{ name: 'my-kh', params: { language: $route.params.language }}">
              <button class="btn btn-primary" style="font-size: 15px; border-radius: 5px;">{{msglist[$route.params.language][17]}}</button><!--右上方 [我的KH] 按鍵 -->
            </router-link></div>
    </div> 
    
		<div class="col-12 row mx-0 px-0 py-2 mb-0" style="background: #fffdb2;">
		  		<div class="col-12 px-0 row mx-0">
		  				<!--<div class="col-auto align-self-center"><img style="width:40px;" src="data:image/png;base64,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"></div>
		  		    --><div class="col border-left align-self-center" style="width:300px">
				  			<div class="col-12 px-4 py-1 row font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][22]}}<!--總水量-->
				  			<div class="col-auto px-2 row mx-0 align-self-center" style="font-size:1rem">
                  <input style="height:30px;font-size:1rem; font-weight: bold" v-model="TankV" maxlength="4" size="3" class="col form-control text-center" name="TankV" type="text"> 
                  <span class="col-auto px-2 align-self-center">{{msglist[$route.params.language][24]}}</span> <!--(公升)-->  
                </div></div>
				  			<div class="col-12 px-4 py-1 row font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][23]}}<!--鈣反大小-->
				  			<div class="col-auto px-2 row mx-0 align-self-center" style="font-size:1rem">
                  <input style="height:30px;font-size:1rem; font-weight: bold" v-model="CaRV" maxlength="4" size="3" class="col form-control text-center" name="CaRV" type="text"> 
                  <span class="col-auto px-2 align-self-center">{{msglist[$route.params.language][24]}}</span>
                </div></div>
				  			<div class="col-12 px-4 py-1 row font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][25]}}<!--珊瑚數量-->
				  			<div class="col-auto px-2 row mx-0 align-self-center" style="min-width: 100px;">
				  				<select  style="padding:5px;height:30px;font-size:1rem; font-weight: bold" v-model="CoralD" name="Coral_density" class="form-control">
				  					<option value="0.5" selected="selected">{{msglist[$route.params.language][26]}}</option><!--少-->
				  					<option value="1">{{msglist[$route.params.language][27]}}</option><!--中-->
				  					<option value="2">{{msglist[$route.params.language][28]}}</option><!--滿-->
				  				</select>
				  			</div>
		  				</div></div>

		  				<div class="col-12 row mx-0 px-0 py-2 mb-0 justify-content-center" style="background: #fffdb2;">
						  			<button @click=generate :disabled="disabled" class="btn btn-primary mr-2" style="min-width: 150px;">{{msglist[$route.params.language][29]}}</button><!--自動產生建議值-->
						  			<button @click=cancel class="btn btn-secondary" style="min-width: 150px;">{{msglist[$route.params.language][30]}}</button>
						  	</div>
		  		</div>
		  	</div>
        
        <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;" src="../assets/KHA.png"></div>
                <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem"> {{msglist[$route.params.language][31]}}</div><!--KHA 序號-->
				  			<div class="col-12 px-0 mt-0 row mx-0 align-self-center" style="width:160px">
                  <input style="height:30px;font-size:1rem; font-weight: bold" v-model="PairDev" maxlength="12" class="col form-control text-center" name="PairDev" type="text"></div>
		  				</div>
		  		</div>
		  	</div>         
        <!--控制模式:大鈣反，開關出水小鈣反，恆流，設定流速
        <div v-if="serial_num <40" class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
            <div class="col-12 px-0 row mx-0">
                <div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACsElEQVR4nO2cQU4bQRBFfxbMHQK5EAcIZyCyTxdyBRIrQI4Amyhih4SzLzShkKIRUbDp5v/u/k9qiY3bj/o1dtnQAxhjzDAcAHjHloA9/nAC4A7APYCPxDBO7PHILYDI9YsYyK09HonFYhH2cCEkG4MukNjDhdBsDLpAYg8XQrMx6AKJPVwIzcagCyT2cCE0G4MukNjDhdBsDLpAYg8XgtMYE4A1gA2A38884f/W/JhvAFa5Vy1ihCv1EMCPPUL417oC8B51iN4DmQqH8bQu80+tpYneA1lXCONpfUJ5ovdANouNP+dL2K4cAThb7PUV5YneA9kuNp4Luy8fFnvN/xBRmug9kNIb1y5YvFEgtKnTgYhNnQ5EbOp0IGJT5/zG6zd1oalzKXC256Q1T1hfOhh7t+wGXVW8RE9Rnmhsitt5vymngNJhfG/0q5NgB4IcyS4LhnHR8JeLoRAIspvnKeD8mdfRl6xtPva00pUxXCCtEJV/wdamzu4D2bQydapcelHZo5mpc5RAplamzlECaWbqHCmQJqbO0QKRR6UQIeJBR6UQYQ8XQrIx6AKJPVwIzcagCyT2cCE0G4MukNjDhdBsDLpAYg8XQrMx6AKJPVwIzcagCyT2cCE0G4MukNjDhdBsDLpAYg8XQrMx3kpg8h0ldAI59B0ldAKZ2Gf7dqT7l6x1hTC6vqNE92f7dqT7QLaNHQPoPpAovH9rvnIC4UAcyGvwFdL5FS0ncO83da1ANq2c7RvlCllV/GDY4h0l6AJTK2f7RgmkmbN9IwXSxNm+0QJpBXo96AJi0OtBF0js4UJoNgZdILGHC6HZGHSBxB4uhGZj0AUSe7gQmo1BF0js4UJoNgZdILGHC6HZGHSBxB4uhGZj3Pz15NcMgcQeyTGAn7nmn1kc28MYYwwMHgA1YhM2+xMaOwAAAABJRU5ErkJggg=="></div>
                <div class="col border-left align-self-center">
                  <div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][1]}}</div>
                  <div class="col-12 px-0 mt-0 row mx-0 align-self-center" style="width:200px">
                    <select style="padding:5px;height:30px;font-size:1rem;font-weight: bold" v-model="tune_both" name="tune_both_value" class="form-control">
                      <option value="1" selected="selected">{{msglist[$route.params.language][2]}}</option>0. 
                      <option value="0">{{msglist[$route.params.language][3]}}</option> 1. 
                    </select>
                  </div>
                </div>
            </div>
        </div>
      -->
        <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
            <div class="col-12 px-0 row mx-0">
                <div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADKUlEQVR4nO1YXUgVQRT+3PPNWiBSIVQQJZH2C6G3P6mHiix7qpcKCSIQsqAgiqAfKHpIfAnsJQJfMpKICOklAglfCiKkqIeIQoiwCJ+KjDRCY+AsDJdLXvfuuiPcgQO7c+ac+b5zzszuDBCvzamsrFwOYAlmcyN5luQkyd8A5sew3yAiB4wxa5FlE5E3SsTK8Rj23dZWRK4iq2aMaVQCPxTMC1cfhuEqG22Sm6M+Edlu+wDUisgOkk/VxwMR2euYLyN5kuQ5EdkDoCI1IiJyQ0FcITlsn8MwXB3pSV5Q/V2nb8D2GWOOisgzJ5s2EB/tmCAIDpMcd3WWsF2PafAISY4oeBv5LgXTWSyRMAxXkuxTu25jzDoAi0j+Ijmh2WiOyldEriXOQkT2q/O3CnCrgh626mKIFFojxpg2fX/uzNWife8SJxJFkmS/MeYYyXaSYzphS1wiJC+pzZ3IJgzDOu37kzSPmgI17Mo9BXVe33uLJWL71eaxY7NNxwwlyoLkKXX83u5AkZA843xT5kWgtCRqjDE5kt/yiNx0yC+w603Xx7iI7LR9JB/lZymRJiKD6vhynqqC5GfVtQNYTPJnXrZGXSJOBqx8V/+dBbL81W7JSfKoshPp7lSbrwyC4KDVBUFwRIGuF5FbJHusLgiCQ1ZvsxOZkDxN8r6IXHeCtY/kbZIPtewWJkWg0W6Ns93HUgATAPpLAOCFjxyASQCDJYDwwkfOBxAoE/EsmihnxLNoIqaPuQC2ANgF4IQ6+KDvVupmAkSpPpoAfFGj/0kfgEpfiQQAPqnBa/34FJIRHXPRVyL1OnhoinNys44bSANEEiVe7ITTBRaHSFMpJd6gyldTTLJRx71MiUhQaolXAfgLYAxAm5NCV3YD6FUHPSkRqU+ixDuKSKeVUQBrUiKSS6rEWzXqhdL5BEAXgBVFgopDpCGNEq/WktqE+G26RKrSKPGsfi86ki7xLP+1WpMscV9+GqtLLXFfiOTKR12foolyRjyLJsoZ8SyaKGckw9OdT98RLy8wcjN9uvOFiG8XGNmf7rIm4ssFhp+nO2S0a/lwgYGkHGRygfEP21vvftZoxWYAAAAASUVORK5CYII="></div>
                  <div class="col border-left align-self-center">
                  <div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][21]}}</div><!--自動修改CO2輸出-->
                  <div class="col-12 px-0 mt-0 row mx-0 align-self-center" style="width:160px">
                    <select style="padding:5px;height:30px;font-size:1rem;font-weight: bold" v-model="tune_both" name="tune_both_value" class="form-control">
                      <option value="1" selected="selected">On</option>
                      <option value="0">Off</option>
                    </select>
                  </div>
                </div>
            </div>
        </div>  
        
        <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,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"></div>
              <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][7]}}</div><!--個CO2氣泡，可增加 1 dKH--> 
				  			<div class="col-12 px-0 mt-0 row mx-0 align-self-center" style="width:160px">
                  <input style="height:30px;font-size:1rem;font-weight: bold" v-model="KHdosing" maxlength="4" class="col form-control text-center" name="KHdosing" type="text"> 
                  <span class="col-auto px-2 align-self-center">{{msglist[$route.params.language][9]}}</span></div>
		  				</div>
		  		</div>
		  	</div>
          
        <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,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"></div>
                <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][8]}}</div><!--每小時最多修改-->
				  			<div class="col-12 px-0 mt-0 row mx-0 align-self-center" style="width:160px">
                  <input style="height:30px;font-size:1rem;font-weight: bold" v-model="maxKHdosingPerHr" maxlength="4" class="col form-control text-center" name="maxKHdosingPerHr" type="text"> 
                  <span class="col-auto px-2 align-self-center">{{msglist[$route.params.language][9]}}</span>
                </div>
		  				</div>
		  		 </div>
		  	</div>
        
        <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAChElEQVR4nO2aO2sVQRiGH0G08HYEo40pvXQqoikE0X8gXhCxEBT8BSKWXpBYqj9AbC1MxEKMChJPDlaKXWpBxVNoohEs1IwMvAtL2JMz0dmTzDf7wMCy8+3MfO98c9mdhYaGmHQAFzm1SQhXU0oGF7nBjQAkGgEu1yHQrsH5VxjCLejR5HrYtACdAazBK1oAN4AJKAkBChoBaCIAl9O7gIswBJLeCLkeAixng/vV8wOYBp4Dl4GdMSpLSYCq9ALY/z+VxRgCsehX3jpgF3AMuAd8lf08cBdYbV2AhbSAUeBnKRr8vWwEKNgHvNezk8AaMhPAMwx81PN3yFAAzwENhz+KiuwE8NxSGc/IVIAWMKNyduQogOe+yrmEoY3Qd2AscPd3XM9MhFSWigBF+gJs71PObtlOh1QWYwjETlV4p58o/0Gfdm0oRU2tArQH/FV4WDazAW3r64+LIMByENrORgACI8DVNKGt+AhoL3H8mRMgNTq5/HPQizqW1qT4V0caATAWAS7XIdCuaXfZ0JA4a/UleFLX2TFaGus3yYy9wC/gt5K/3kMmrFLY+56/raMxfz2lPPOcl8OfgE3ARuCD7p3DOC2gK2dPle6f1r3uUs4IU+S6HH1dEe5TyruKUVo6+PBH4ocq8keU578bbsZw7z9cxGbMahS01LPeuYOL2I3IZkYTpBkuyrGXAbbFEnkBQ0zIqTMBtmdl+xRDdOXUUIDtNtl+xhBzcsr/LEWM47HUeCenDgfYHpXtWwxxQ06NB9g+trgUbgW+yTH/p2gvrpQOUbdgjJPa6XkHHwFHNCesV9gXPT+vHyVMcqIUCVVp1rLzBUPaFr/R6jCn62sWw76BSPwFsjOHITy5npkAAAAASUVORK5CYII="></div>
                <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][11]}} </div><!--鈣反出水量-->
				  			<div class="col-12 px-0 mt-0 row mx-0 align-self-center">
				  				<input v-model="ValveOpen" class="form-control col align-self-center" type="range" min="0" max="95" style="width: 100px; height: 10px;">
				  				<input v-model="ValveOpen" class="form-control align-self-center ml-2 px-0 text-center" type="number" min="0" max="95" style="height:30px;font-size:1rem;font-weight: bold;width:50px;background: none;border: none;"></div>
		  				</div>
		  		</div>
		  	</div>

        <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(200, 242, 242);">

          <div class="col-12 px-0 row mx-0 font-weight-bold">
              <div class="px-3 align-self-center" >{{msglist[$route.params.language][13]}}</div> <!--時間-->
              <div class="col align-self-center text-right">{{msglist[$route.params.language][14]}}</div> <!--CO2 氣泡數-->
          </div>
        </div>  
        <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
          <div v-for="(item, index) in targetKHarr" :key="index" class="col-12 px-0 row mx-0 font-weight-bold">
		  				<div class="px-3 align-self-center" style="width: 35px;">
                <span v-if="index < 10">0</span><span>{{index}}</span>
              </div>
		  				<div class="col align-self-center row mx-0 ">
				  				<input v-model="targetKHarr[index]" class="form-control col align-self-center" type="range" min="0" max="240" style="width: 50%; height: 10px;">
				  				<input v-model="targetKHarr[index]" class="form-control align-self-center ml-2 px-0 text-center" type="number" min="0" max="240" style="height:30px;font-size:1rem;font-weight: bold;width:50px;background: none;border: none;">
				  		</div>
		  		</div>
        </div>
          
        <div class="col-12 row mx-0 px-0 py-3 mb-1 justify-content-center" style="background: rgb(242, 242, 242);">
		  			<button v-if="name!=='khacra'" @click=apply :disabled="disabled" class="btn btn-primary" style="min-width: 150px;">{{msglist[$route.params.language][19]}}</button><!--套用-->
		  	  </div>

		  	<div class="col-12 row mx-0 px-0 py-2 mb-1 justify-content-center">
		  			<div class="col-12 px-0">{{msglist[$route.params.language][15]}}</div>
		  			<div class="col-12 px-0 mt-3">{{msglist[$route.params.language][16]}}</div>
		  	</div>
	
</div></div>
</template>
<script>
//import Log from 'loglevel';
import has from 'lodash/has';
import {
	mapLang
} from "../routes.js";

const mlist = {
	'en': [
		'CRA Settings',
		'Control Mode',
		'0. Less demand, on/off flow', '1. High demand, constant flow', '2. Constant PH, on/off flow',
        'Fix output to reach KH target','Fix previous output for stable KH',
        ': Maximum CO2 bubbles or bubbles to increase 1 dKH', 'Maximum adj. per hour',
		'bubbles','CO2 bubble period','Water flow rate','Minimum PH',
        'Hour',
        'CO2 bubbles',
        '[Apply] to take effect in the next measurement.',
        'To take effect immediately, select [SYNC] in CRA LCD',
        'My KH','Error','Apply','Applied',
        'Adj. CO2 automatically',
        'Tank volume','CaRx size','(L)','Coral count','small','medium','full','Suggested setup','Cancel',
        'Paired KHA serial'],
  'vi': [
    'Cài Đặt CRA',
		'Chế Độ Điều Khiển',
		'0. Ít nhu cầu hơn, bật/tắt dòng chảy', '1. Nhu cầu cao, dòng chảy liên tục', '2. PH không đổi, bật/tắt dòng chảy',
        'Khắc phục đầu ra để đạt mục tiêu KH','Sửa đầu ra trước đó cho KH ổn định',
        ': Bong bóng CO2 tối đa hoặc bong bóng tăng 1 dKH', 'Điều chỉnh tối đa trên giờ',
		'Bong Bóng','Thời Kỳ Bong Bóng CO2','Tốc Độ Dòng Nước','PH tối thiểu',
        'Giờ',
        'Bong Bóng CO2',
        '[Apply] có hiệu lực ở lần đo tiếp theo.',
        'Để có hiệu lực ngay lập tức, hãy chọn [SYNC] trong CRA LCD',
        'KH của tôi','Lỗi','Áp dụng','Đã áp dụng',
        'Adj. CO2 automatically',
        'Thể tích bể','Kích thước CaRx','(L)','Số lượng san hô','nhỏ','trung bình','đầy đủ','Thiết lập được đề xuất','Hủy',
        'Đã ghép nối sê-ri KHA'],
  'ms': [
		'CRA Settings',
		'Control Mode',
		'0. Less demand, on/off flow', '1. High demand, constant flow', '2. Constant PH, on/off flow',
        'Fix output to reach KH target','Fix previous output for stable KH',
        ': Maximum CO2 bubbles or bubbles to increase 1 dKH', 'Maximum adj. per hour',
		'bubbles','CO2 bubble period','Water flow rate','Minimum PH',
        'Hour',
        'CO2 bubbles',
        '[Apply] to take effect in the next measurement.',
        'To take effect immediately, select [SYNC] in CRA LCD',
        'My KH','Error','Apply','Applied',
        'Adj. CO2 automatically',
        'Tank volume','CaRx size','(L)','Coral count','small','medium','full','Suggested setup','Cancel',
        'Paired KHA serial'],
	'tw': [
		'CRA設定',
		'控制模式: ',
		'0. 大鈣反，開關水，大流量','1. 小鈣反，恆流，小流量','2. 穩定鈣反PH值，開關出水',
		'修改現在CO2輸出，達KH目標','修改歷史CO2輸出，穩定KH',
		'最多氣泡數 或 增加1 dKH氣泡數','每小時最多修改','個',
		'幾秒輸出一次CO2','鈣反出水量','PH最低值',
        '時間 ',
        'CO2 氣泡數',
        '[套用] 鍵, 設定值會在下次量測時生效',
        '要立即生效，在CRA LCD上選[Sync]同步',
        '我的KH','錯誤','套用','已套用','自動調整CO2氣泡數',
        '魚缸水量','鈣反大小','公升','珊瑚數量','少','中','滿','設定值建議','取消',
        '配對KHA序號'],
	'cn': [
		'CRA设定',
		'控制模式: ',
		'0. 大钙反，开关出水','1. 小钙反，恆流，设定流速','2. 稳定钙反PH值，开关出水',
		'修改现在CO2输出，达KH目标','修改历史CO2输出，稳定KH',
		'最多气泡数 或 增加1 dKH气泡数','每小时最多修改','个',
		'几秒输出一次CO2','钙反出水量','PH最低值',
        '时间',
        'CO2 气泡数',
        '[套用] 键, 设定值会在下次量测时生效',
        '要立即生效，在CRA LCD上选[Sync]同步',
        '我的KH','错误','套用','已套用','自动调整CO2输出',
        '鱼缸水量','钙反大小','公升','珊瑚数量','少','中','满','设定值建议','取消',
        '配对KHA序号']
}


//let PURL = process.env.SERVER;

function startCfg(Vue) {
    let PURL = localStorage.getItem("server") || process.env.SERVER;
    let url = PURL + '/api/v1/KH/start-config';
    let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
    let body = {
        "user": user.name,
        "serial": ''
    };
    let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload
    //console.log('server: ', PURL, process.env, user);
    has(user, 'data.devices') ? body.serial = user.data.devices[sidx] : '';
    
    //let tKH = buf2hex(Vue.targetKHarr);
    //Vue.targetKH = JSON.stringify(tKH);
    ////////// check value will be saved ////////// 
       for(let i = 0; i < 24; i++) {
          if (Vue.targetKHarr[i] >240) {Vue.targetKHarr[i]=240;}  // force to use mode 1
          //if (Vue.Cmode ==="0") { if (Vue.targetKHarr[i] >120) {Vue.targetKHarr[i]=120;}}  // large CaRx mode CO2 bubble < 120
            //if (Vue.Cmode ==="1") { if (Vue.targetKHarr[i] >240) {Vue.targetKHarr[i]=240;}}  // small CaRx mode CO2 bubble < 240
            //if (Vue.Cmode ==="2") { if (Vue.targetKHarr[i] >60) {Vue.targetKHarr[i]=60;}}    // Fix PH mode Flow time < 60 min
        } // for
        Vue.targetKH =buf2hex(Vue.targetKHarr);
        //console.log('new targetKH: ', Vue.targetKH, Vue.targetKHarr);
    body['field8'] = Vue.targetKH;
      
        if (Vue.tune_both < 0) {Vue.tune_both = 0;}; if (Vue.tune_both > 1) {Vue.tune_both = 1;};
            Vue.tune_now = Vue.tune_both; Vue.tune_past = Vue.tune_both;  // combine tune_now and tune_past as tune_both
        
        Vue.Cmode = 1; // force to use mode 1
        Vue.KHperiod = 60; // not adjustable
        Vue.PHLowest = 4; // not adjustable
    
    if (Vue.PairDev.length < 12) {Vue.PairDev ="";}  // old value of field11 = 15; need toset it = "" to prevent website display 15
    body['field11'] = Vue.PairDev;  
    
    body['field12'] = "" + Vue.Cmode + Vue.tune_now + Vue.tune_past + Vue.KHperiod + (Vue.PHLowest * 10) ; //每個都固定位數，可用此法
        //console.log("field12 ", body['field12'], 'Cmode ', Vue.Cmode, "tune_now", Vue.tune_now, "tune_nowpast", Vue.tune_past, "CO2period", Vue.KHperiod, "PH low", Vue.PHLowest);
        
        if (Vue.ValveOpen < 0) {Vue.ValveOpen = 0;}; if (Vue.ValveOpen > 95) {Vue.ValveOpen = 95;};
        if (Vue.KHdosing < 1) {Vue.KHdosing = 1;}; if (Vue.KHdosing > 999) {Vue.KHdosing = 999;};
        if (Vue.maxKHdosingPerHr < 0) {Vue.maxKHdosingPerHr = 0;}; if (Vue.maxKHdosingPerHr > 240) {Vue.maxKHdosingPerHr = 240;};
    body['field5'] = Number(Vue.ValveOpen)*1000000 + Number(Vue.KHdosing)*1000 + Number(Vue.maxKHdosingPerHr);
        if (Vue.ValveOpen < 10) {body['field5'] = "0" + JSON.stringify(body['field5']);  //每個位數不固定，可用此法，第一個位數不足要補"0"
        } else {body['field5'] = JSON.stringify(body['field5']) }
        //console.log("field5 ", body['field5'], 'ValveOpen ', Vue.ValveOpen, "mldKH", Vue.KHdosing, "maxml", Vue.maxKHdosingPerHr);
        
    /////// update parameters in localstorage ////////
    if (user.KHdosing) {
      Vue.$set(user.targetKH, sidx, body['field8']);
      Vue.$set(user.PairDev, sidx, body['field11']);
      Vue.$set(user.CalRemain, sidx, body['field12']);
      Vue.$set(user.KHdosing, sidx, body['field5']);
    localStorage.setItem('user', JSON.stringify(user));
    }
    // asynch call
    let p1 = Vue.$http.post(url, body);
    //let p2 = Vue.$http.get(PURL + '/api/v1/KH/' + body.serial + '/pending-config/field3'); // 查詢 pending config 狀態
    //Promise.all([p1, p2]).then(([r1, r2]) => {
    Promise.all([p1]).then(([r1]) => {
        console.log("CaRx-settings -- new parameters applied");
        Vue.setMsg(mlist[Vue.getLang()][20], 5);
    }, reason => {
        console.log('server error: ', reason);
        Vue.setMsg1(mlist[Vue.getLang()][18], 2);
    });
}

function fetch89(Vue) {

  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  
  let body = {
    "user": user.name,
    "password": ''
  };
  if (Vue.$route.params.sidx != null) {localStorage.setItem('sidx', Vue.$route.params.sidx);} // when reload webpage, sidx will be forget and = undefined, null
      let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload
      let serial = user.data.devices[sidx]; 
      Vue.serial_num = Number(serial.split('-')[2]); // 40 in CA1-00-00040
   
  if (user && user.KHdosing) { // if localstorage user && user.sleep exist, then restore Vue.u parameters from localstorage
      //console.log("KH-settings fetch89 localstorage user: ",  user);
      //console.log("KH-settings fetch89 $store user: ",  Vue.$store.getters.user);
      //console.log('device: ', localStorage, user, sidx);
        //////// get parameters from localstorage /////
        Vue.name=user.name;
        Vue.targetKH = user.targetKH[sidx];    // Set CO2 pulse
            let tKHarr = Vue.targetKH.split("");
                  //console.log('get targetKH: ', Vue.targetKH, Vue.targetKHarr);
            for(let i = 0; i < tKHarr.length; i+=2) {
              let p=i/2; tKHarr[p]=tKHarr[i]+tKHarr[i+1] ;} 
                  //console.log('convert targetKH: ', tKHarr);
            for(let i = 0; i < 24; i++) {
              tKHarr[i] = parseInt(tKHarr[i], 16) ;}
                  //console.log('parseINT targetKH: ', tKHarr);
            Vue.targetKHarr = tKHarr.slice(0, 24);
                  //console.log('targetKH: ', Vue.targetKHarr);

      Vue.PairDev = user.PairDev[sidx];  // KHA serial KH1-00-00001
      if (Vue.PairDev.length < 12) {Vue.PairDev ="";}  // old value of field11 = 15; need toset it = "" to prevent website display 15
  
      let mode = Math.floor(user.CalRemain[sidx]/10000); // field12 = user.CalRemain //Vue.Cmode (1 char) + Vue.tune_now (1) + Vue.tune_past (1) + Vue.KHperiod (2)+ Vue.PHLowest (2);
            Vue.Cmode = Math.floor(mode/100);
            Vue.tune_now = Math.floor((mode % 100) / 10);
            Vue.tune_past = (mode % 100) % 10;
            Vue.tune_both = Vue.tune_now;   // combine tune_now and tune_past as tune_both
      let khph = Math.floor(user.CalRemain[sidx] % 10000);
            Vue.KHperiod = Math.floor(khph/100);
            Vue.PHLowest = Math.floor(khph % 100) / 10;
      Vue.ValveOpen = Math.floor(user.KHdosing[sidx]/1000000);   // field5 =  KHdosing  //Vue.ValveOpen (2 char) + Vue.KHdosing (3) + Vue.maxKHdosingPerHr (3 );
      let dos = Math.floor(user.KHdosing[sidx] % 1000000);
            Vue.KHdosing = Math.floor(dos/1000);
            Vue.maxKHdosingPerHr = Math.floor(dos % 1000);
      console.log("CaRx-settings -- get parameters from localstorage");
  
  } else {  
      let PURL = localStorage.getItem("server") || process.env.SERVER;
      let urls = PURL + '/api/v1/KH/' + user.data.devices[sidx] + '/' + 'all_field';
			// asynch call
			let ps = Vue.$http.post(urls, body);
			Promise.all([ps]).then(([rs]) => {
				if ((rs.status === 200 || rs.status === 204)) {

          Vue.targetKH = rs.data['field8'];
      let tKHarr = Vue.targetKH.split("");
            //console.log('get targetKH: ', Vue.targetKH, Vue.targetKHarr);
      for(let i = 0; i < tKHarr.length; i+=2) {
        let p=i/2; tKHarr[p]=tKHarr[i]+tKHarr[i+1] ;} 
            //console.log('convert targetKH: ', tKHarr);
      for(let i = 0; i < 24; i++) {
        tKHarr[i] = parseInt(tKHarr[i], 16) ;}
            //console.log('parseINT targetKH: ', tKHarr);
      Vue.targetKHarr = tKHarr.slice(0, 24);
            //console.log('targetKH: ', Vue.targetKHarr);
          Vue.PairDev = rs.data['field11'];  // KHA serial KH1-00-00001
      if (Vue.PairDev.length < 12) {Vue.PairDev ="";}  // old value of field11 = 15; need toset it = "" to prevent website display 15

          let mode = Math.floor(rs.data['field12']/10000);
            Vue.Cmode = Math.floor(mode/100);
            Vue.tune_now = Math.floor((mode % 100) / 10);
            Vue.tune_past = (mode % 100) % 10;
            Vue.tune_both = Vue.tune_now;   // combine tune_now and tune_past as tune_both
          let khph = Math.floor(rs.data['field12'] % 10000);
            Vue.KHperiod = Math.floor(khph/100);
            Vue.PHLowest = Math.floor(khph % 100) / 10;
          Vue.ValveOpen = Math.floor(rs.data['field5']/1000000);      
          let dos = Math.floor(rs.data['field5'] % 1000000);
            Vue.KHdosing = Math.floor(dos/1000);
            Vue.maxKHdosingPerHr = Math.floor(dos % 1000);
          console.log("KH-settings -- get parameters from server");
      
	}
  }, reason => {
      console.log('server error: ', reason);
				Vue.setMsg_logout(mlist[Vue.getLang()][18], 2);
  });
      
  }  // if user && user.sleep
  
  
}


function buf2hex(buffer) { // buffer is an ArrayBuffer
  
  const byteArray = new Uint8Array(buffer);// create a byte array (Uint8Array) that we can use to read the array buffer
  const hexParts = []; // for each element, we want to get its two-digit hexadecimal representation
  for(let i = 0; i < byteArray.length; i++) {
    const hex = byteArray[i].toString(16);// convert value to hexadecimal
    const paddedHex = ('00' + hex).slice(-2); // pad with zeros to length 2
    hexParts.push(paddedHex);// push to array
  }
  return hexParts.join('');// join all the hex values of the elements into a single string
}


export default {
  
  data: () => {
    return {
      disabled: false,
      title: "KH Setting",
      targetKHarr: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
      targetKH: "",
      TankV:"0",
      CaRV:"0",
      CaRmax:"0",
      CoralD:"1",
      Cmode: "1",
      tune_both: "0",
      tune_now : "1",
      tune_past: "1",
      KHdosing: "0",
      maxKHdosingPerHr: "0",
      PHLowest: "4.1", // not adjustable
      KHperiod: "60",  // not adjustable
      ValveOpen:"0",
      PairDev:"",
      message: "",
      msglist: mlist, 
      name:"",
      time_out:"",
      //userS: localStorage.getItem('user'),
      slide_S: {width: "50%", height: "10px"},
      slide_L: {width: "60%", height: "10px"},
      serial_num: "", // 40 in CA1-00-00040
    }
  },
  created: function () {
    // `this` points to the vm instance
	fetch89(this);
    //console.log("remove address bar");
    window.scrollTo( 0, 1); // to remove address bar
  },
  destroyed: function () {
    //console.log('CaRx-setting destroy step');
    //clearInterval(this.time_out);
    clearTimeout(this.time_out);
  },
  computed: {
	alertObject: function() {
        if (this.message) {
            return {"alert": true, "alert-info": true, "alert-warning":true, "alert-danger": false};  // alert-danger 紅色背景 alert-waring 黃色背景
        } else if (this.message.match('error')) {
            return {"alert": true, "alert-danger": true, "alert-info": false};
        } else {
            return {"alert": false, "alert-info": false, "alert-danger": false};
        }
    },

  },
  methods: {
    getLang: function () {
		  //console.log("lang: ", mapLang(), this.$route.params);
		  if (has(this.$route, "params.language")) {
			  return this.$route.params.language;
		  } else {
			  return mapLang();
		  }
	}, 
    setMsg: function (message, timer) {
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
        }, timer*1000);
    },
    setMsg_logout: function (message, timer) {  // show message for timer sec and logout
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
            ////// to complete logout and show login page need this 3 items
            this.$store.dispatch("setUser", {name: '', token: ''});
            this.$auth.destroyToken();
            this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
        }, timer*1000);
    },
    apply: function () {
      //console.log("this: ", this.$http, startCfg, this.$store.user);
      this.disable();
      startCfg(this);
    },
    generate: function () {
      this.tune_both=1; this.tune_now=this.tune_both; this.tune_past=this.tune_both;
      this.KHdosing = Math.round(0.214*this.TankV/4);  if (this.KHdosing > 240) {this.KHdosing = 240;}  // limit to 480  // /4 to reduce KH change speed from experience
      this.CaRmax = 24*this.CaRV;  // define maximum bubble count/hr for this Calcium reactor, 10 L calcium reactor is max 240 bubble count/hr
      //if (this.CaRmax > this.KHdosing*this.CoralD) {this.Cmode="0";} else {this.Cmode="1";}
      this.Cmode="1";
      this.maxKHdosingPerHr = Math.round(this.KHdosing/2); if (this.maxKHdosingPerHr > 240) {this.maxKHdosingPerHr = 240;}  // limit to 240
      let maxKH = Math.round(this.KHdosing/2); if (maxKH > 240) {maxKH = 240;}
      let halfmaxKH = Math.round(this.KHdosing/4);  if (halfmaxKH > 240) {halfmaxKH = 240;}
      this.PHLowest = "4.1";
      this.KHperiod ="60";
      this.ValveOpen = "95";
      for(let i = 0; i < 24; i++) {
            if (this.CoralD ==="0.5") { this.targetKHarr[i]=0;}  // low coral density, then suggest 0 CO2 bubble 
            if (this.CoralD ==="1") { this.targetKHarr[i]=halfmaxKH;}  // medium coral density, then suggest 1/2 of max CO2 bubble count/hr
            if (this.CoralD ==="2") { this.targetKHarr[i]=maxKH;}    // high coral density, then suggest          max CO2 bubble count/hr
        } // for
      //console.log("this: ", this.$http, startCfg, this.$store.user);
      //startCfg(this);
    },
    cancel: function () {
      
      fetch89(this);
    },
    disable: function() { this.disabled = true; },
    enable: function() { this.disabled = false; },
	},
  mounted() {
		if (this.$auth.loggedIn()) {
			this.time_out=setTimeout( () => {     // return to my-kh after 5 min
            this.$router.push({ name: 'my-kh', params: { language: this.$route.params.language } })
        }, 600*1000);
			//return this.fillData(1);
		} else {
      this.$auth.destroyToken();
			this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
		}
  }

} // export default
</script>

<style type="text/css">

input[type="range"]{
  overflow:hidden;     /* 限定範圍 */
  width:200px;
  height:20px;
  outline : none;      /* 避免點選會有藍線或虛線 */
  background:none;
}
</style>



// WEBPACK FOOTER //
// CaRx_settings.vue?4d027b34